var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCashback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#ffff",
    height: "24px",
    width: "24px",
    viewBox: "0 0 24.000000 24.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,24.000000) scale(0.100000,-0.100000)",
    fill: "#ffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 230 c-48 -19 -98 -110 -61 -110 9 0 16 7 16 16 0 8 13 29 29 45 35 35 81 39 111 9 25 -25 50 -26 50 -2 0 11 -15 24 -40 35 -43 18 -73 21 -105 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 158 c-9 -12 -16 -29 -16 -38 0 -9 7 -26 16 -38 23 -33 73 -27 94 11 13 24 13 30 0 55 -21 37 -71 43 -94 10z m59 -8 c3 -5 -1 -10 -11 -10 -13 0 -12 -3 6 -18 20 -16 21 -19 6 -31 -13 -11 -20 -11 -28 -3 -9 9 -7 12 7 12 18 0 17 1 -3 16 -18 13 -21 19 -11 30 14 16 25 18 34 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 104 c0 -8 -13 -29 -29 -45 -35 -35 -81 -39 -111 -9 -25 25 -50 26 -50 2 0 -25 75 -55 119 -48 41 6 87 49 96 89 6 21 4 27 -9 27 -9 0 -16 -7 -16 -16z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashback);
export default __webpack_public_path__ + "static/media/cashback.391c55861012e7da31e9632e7518d3e6.svg";
export { ForwardRef as ReactComponent };